import styled from 'styled-components';

export const UserTextFieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 20px;
  flex-grow: 1;
  width: 50%;
  min-width: 300px;
  @media (max-width: 800px) {
    width: 100%;
    min-width: 200px;
  }
`;
